
import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import PDF_Component from '../PDF_Component.js';
import { Box, CircularProgress } from '@material-ui/core';
import PDF_Comp_02 from '../PDF_Component.js/PDF_Comp_02.js';
import { baseURL } from '../../utils/axois_instance.js';

export const Generate_pdf = () => {
  let { admissionId } = useParams();
  const [pdf_data, setPdf_data] = useState(null)
  const [is_error, setIs_error] = useState(null)
  const [is_loading, setIs_loading] = useState(true)


  console.log({ admissionId });

  const get_data_handle = (id) => {


  }

  useEffect(() => {
    setIs_loading(true)
    axios.get(`${baseURL}/get-admission-pdf/${admissionId}`).then((res) => {
      setIs_loading(false)
      setPdf_data(res.data.data)

    }).catch((error) => {
      setIs_loading(false)
      setIs_error({ message: 'Something went wrong!' })
    })

    return
  }, [admissionId])


  console.log({ pdf_data });

  return pdf_data ?  
  // <PDF_Component state_data={pdf_data} />
  // <Box style={{width:'300px', overflowX:'auto'}}>
    <PDF_Comp_02 state_data={pdf_data} />
  // </Box>
   : <Box sx={{ width: '100dvw', height: '100dvh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <CircularProgress style={{color:'#006838'}} />
    </Box>


}


